import { getBackofficeProjectUrlTemplate, getNotificationsHubUrl, isValidServerUrl } from './common';
import {
    ENVIRONMENT_BASE,
    GOOGLE_MAPS_API_KEY_NON_PROD,
    MadEnvironment,
    TRANSLATIONS_BASE_URL
} from './environment.base';

const originsPerUserType: Record<string, string> = {
    Advisor: 'slot-1.app-test.swissfex.ch',
    Broker: 'slot-1.app-test.swissfex.ch',
    Admin: 'slot-1.app-test.swissfex.ch'
};
let serverUrl = location.host;
if (!isValidServerUrl(serverUrl, originsPerUserType)) {
    serverUrl = 'mad-test-api-slot-1.azurewebsites.net';
}

const apiProtocol = 'https://';
const wsProtocol = 'wss://';

const DFS_IDENTITYSERVER_URL = 'https://auth-dev.swissfex.ch';

const HYPO_DOSSIER_BASE_URL = 'https://swissfexdev.test.hypodossier.ch/v1/static/';
const HYPO_DOSSIER_SERVICE_BASE_URL = 'https://dms.swissfexdev.test.hypodossier.ch/';

const BACKOFFICE_URL = 'https://backoffice-dev.swissfex.ch';

export const environment: MadEnvironment = {
    ...ENVIRONMENT_BASE,
    apiUrl: `${apiProtocol}${serverUrl}/api`,
    backofficeProjectUrl: getBackofficeProjectUrlTemplate(BACKOFFICE_URL),
    dfsIdentityServerUrl: DFS_IDENTITYSERVER_URL,
    diagnosticLogKeyBase: 'SwissFEX.test.slot-1@2024.8.1!',
    features: {
        clarity: {
            isEnabled: false,
            key: null
        },
        hypoDossier: {
            baseUrls: {
                component: HYPO_DOSSIER_BASE_URL,
                service: HYPO_DOSSIER_SERVICE_BASE_URL
            },
            features: {
                closePreviewOnDocumentNotFoundEvent: false
            },
            scriptType: 'module'
        },
        hypoDossierCdp: {
            cdpBackendUrl: 'https://dms.swissfexdev.test.hypodossier.ch',
            cdpIframeUrl: 'https://dmf.swissfexdev.test.hypodossier.ch/cdp',
            authTokenRefreshInterval: 5,
            enableConsoleLogs: true,
            sfxEnableBadgeDebug: true
        },
        documents: {
            useRedesignedDocumentsPage: false
        }
    },
    googleMapsApiKey: GOOGLE_MAPS_API_KEY_NON_PROD,
    name: 'test',
    notificationsUrl: getNotificationsHubUrl(wsProtocol, serverUrl),
    originsPerUserType,
    title: 'SFX Test Slot 1',
    translationsUrl: `${TRANSLATIONS_BASE_URL}test-slot-1/`
};
